var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1657087796593,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2303,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.1 475.9L378.4 339.5c-10.4-10.7-27.4-10.9-38.1-0.5-5.2 4.9-8.2 11.7-8.3 18.9-0.2 7.2 2.6 14.1 7.5 19.2l131.7 136.4-136.4 131.7c-10.7 10.4-10.9 27.4-0.5 38.1 4.9 5.2 11.7 8.2 18.9 8.3 7.2 0.2 14.1-2.6 19.2-7.5l136.4-131.7 131.7 136.4c10.4 10.7 27.4 10.9 38.1 0.5 5.2-4.9 8.2-11.7 8.3-18.9 0.2-7.2-2.6-14.1-7.5-19.2L547.7 514.8l136.4-131.7c10.7-10.4 10.9-27.4 0.5-38.1-4.9-5.2-11.7-8.2-18.9-8.3-7.2-0.2-14.1 2.6-19.2 7.5L510.1 475.9zM220.4 793.2c-155.7-161.3-151.2-418.2 10-574 161.3-155.7 418.2-151.2 574 10 155.7 161.3 151.3 418.2-10 574-161.3 155.7-418.2 151.3-574-10z m0 0",
    "p-id": 2304,
    fill: "#cccccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.68c4a58e.svg";
export { ForwardRef as ReactComponent };